export const TIMEOUT = 50000; // second
export const HEADER_FORM_DATA = {
  "Content-Type": "multipart/form-data",
  Accept: "application/json",
  type: "formData",
};
